var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.6,
    height: 32,
    viewBox: "0 0 33.6 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 .496a1.2 1.2 0 0 0-1.2 1.2v2.8h-.516a3.26 3.26 0 0 0-3.092 2.228l-1.46 4.388a.858.858 0 0 1-.814.586H17.6v-1.2a1.2 1.2 0 0 0-1.2-1.2H10a1.2 1.2 0 0 0-1.2 1.2v6.4a1.2 1.2 0 0 0 1.2 1.2h6.4a1.2 1.2 0 0 0 1.2-1.2v-2.802h1.316a3.26 3.26 0 0 0 3.092-2.228L23.47 7.48a.858.858 0 0 1 .812-.586h.516v1.2a1.2 1.2 0 0 0 1.2 1.2h6.4a1.2 1.2 0 0 0 1.2-1.2v-6.4a1.2 1.2 0 0 0-1.2-1.2h-6.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2 1.696c0-.428.096-.836.268-1.2H3.6l-.246.008A3.6 3.6 0 0 0 0 4.096V20.9l.008.246A3.6 3.6 0 0 0 3.6 24.5h6.798v3.996H7.6l-.164.012a1.2 1.2 0 0 0 .164 2.388h16.8l.164-.01a1.2 1.2 0 0 0-.164-2.39h-2.802V24.5h6.8l.246-.008a3.6 3.6 0 0 0 3.354-3.592V10.896h-6a2.786 2.786 0 0 1-1.77-.63l-.704 2.11a4.858 4.858 0 0 1-4.324 3.312v1.21a2.8 2.8 0 0 1-2.8 2.798H10a2.8 2.8 0 0 1-2.8-2.8v-6.4a2.8 2.8 0 0 1 2.8-2.8h6.4c.988 0 1.856.512 2.354 1.284l.922-2.764a4.858 4.858 0 0 1 3.524-3.2v-1.32Zm-4.002 26.8-.002-3.996h-6.4l.002 3.996h6.4Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlow);
export default __webpack_public_path__ + "static/media/flow.c662febc.svg";
export { ForwardRef as ReactComponent };